import { render, staticRenderFns } from "./LikeButton.vue?vue&type=template&id=4b260b78&scoped=true"
import script from "./LikeButton.vue?vue&type=script&lang=js"
export * from "./LikeButton.vue?vue&type=script&lang=js"
import style0 from "./LikeButton.vue?vue&type=style&index=0&id=4b260b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b260b78",
  null
  
)

export default component.exports